<template>
  <div :class="['box box--quiz-leads', {'box--quiz-leads-main': box.positionIndex < 4}, {'box--quiz-leads-me': isMe}]">
    <div class="box-number">
      <img src="../../assets/images/badge-gold.svg" v-if="box.positionIndex == 1" />
      <img src="../../assets/images/badge-silver.svg" v-else-if="box.positionIndex == 2" />
      <img src="../../assets/images/badge-brown.svg" v-else-if="box.positionIndex == 3" />
      <span class="box-number-inner" v-else>{{box.positionIndex}}.</span>
    </div>
    <div class="box-inner">
      <span class="box-title">{{box.name}}</span>
      <div class="box-bottom">
        <span class="box-points">{{box.points}}</span>
<!--        <span class="box-played">{{box.played}}</span>-->
<!--        <span class="box-reached">{{box.reached}}</span>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
props: ['box'],
name: "LeaderboardPlayerBox",
computed: {
  isMe() {
    return this.box.idUser === this.$store.getters.user.idUser
  }
}
}
</script>

<style scoped>

</style>